module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "confirm"
    }
  }, [_c('div', {
    staticClass: "confirm_wrap user-select"
  }, [_c('p', {
    staticClass: "clearfix title"
  }, [_c('span', {
    staticClass: "pull-left color_9"
  }, [_vm._v("确认操作")]), _vm._v(" "), _c('i', {
    staticClass: "glyphicon icon_off pull-right cursor",
    on: {
      "click": _vm.confirmOff
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "top_content text-center color_6"
  }, [_vm._v("\n\t\t\t\t确认" + _vm._s(_vm.bigMsg) + "\n\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "text-center color_6"
  }, [_c('small', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.smallMsg) + "\n\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "text-center margin_btn"
  }, [_c('span', {
    staticClass: "btn Cbtn btn_default",
    on: {
      "click": _vm.confirmTrue
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn_qx",
    on: {
      "click": _vm.confirmOff
    }
  }, [_vm._v("取消")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-e2f3c190"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/confirm/confirm.vue
// module id = 1286
// module chunks = 1